module.exports = __webpack_public_path__ + "static/media/1006121.7ff6c173.png";